import { render, staticRenderFns } from "./CustomerTabSettings.vue?vue&type=template&id=2af35ca2&scoped=true"
import script from "./CustomerTabSettings.vue?vue&type=script&lang=ts"
export * from "./CustomerTabSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af35ca2",
  null
  
)

export default component.exports